// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"index_searchWrapper__1RUL6"};